export default __webpack_public_path__ + "f8deb1b6d3244c095a5fc4237879eee3.png";